import React from "react";

import styles from "containers/Form/SimplifiedBuilder/Components/styles.css";

export const QuestionHeader = ({ config, onChangeConfig }) => {
	const onLabelChange = event => onChangeConfig({
		label: event.target.value,
		// eslint-disable-next-line camelcase
		i18n: { en_us: { label: event.target.value } },
	});

	return (
		<div className={`${styles.toolbar} ${styles.marginBottom}`}>
			<div className="ui input" style={{ flexGrow: 42 }}>
				<input
					aria-label="Field question"
					type="text"
					value={config.label || ""}
					onChange={onLabelChange}
					placeholder="Question Header Field"
					data-testid="question-header-input"
				/>
			</div>
		</div>
	);
};
